export const plain = () => `
  
`
export default plain
